<template>
  <div class="admin-room-container figma-property-page">
    <div class="figma-white-card">
      <div class="figma-page-header">
        <div class="figma-page-title">{{ $t('committeeExpiredContract.pageTitle') }}</div>
        <div class="figma-header-divider"></div>

        <!-- 筛选行：刷新 / 合同名称 / 合同编号 / 合同类型 / 搜索 -->
        <div class="figma-filter-row">
          <el-button size="small" class="figma-btn-refresh" title="刷新" @click="getList">
            <i class="el-icon-refresh-right"></i>
          </el-button>

          <div class="figma-search-group">
            <el-input v-model="conditions.contractName" size="small" :placeholder="$t('committeeExpiredContract.search.contractNamePlaceholder')" clearable class="figma-filter-control" />

            <el-input v-model="conditions.contractNo" size="small" :placeholder="$t('committeeExpiredContract.search.contractNoPlaceholder')" clearable class="figma-filter-control" />

            <el-select v-model="conditions.contractType" size="small" clearable filterable :placeholder="$t('committeeExpiredContract.search.contractTypePlaceholder')" class="figma-filter-control">
              <el-option v-for="t in contractTypeList" :key="t.id || t.typeId" :label="t.name || t.typeName" :value="t.id || t.typeId" />
            </el-select>

            <el-button size="small" class="figma-btn-search" @click="handleSearch">
              <i class="el-icon-search"></i>搜索
            </el-button>
          </div>
        </div>
      </div>

      <div class="figma-table-section">
        <el-table :data="tableData" style="width: 100%" :header-cell-style="headerCellStyle" :cell-style="cellStyle" :row-class-name="rowClassName" :loading="loading">
          <el-table-column prop="communityName" :label="$t('committeeExpiredContract.table.communityName')" min-width="152" show-overflow-tooltip />
          <el-table-column prop="contractCode" :label="$t('committeeExpiredContract.table.contractCode')" min-width="139" show-overflow-tooltip />
          <el-table-column prop="parentContractCode" :label="$t('committeeExpiredContract.table.parentContractCode')" min-width="130" show-overflow-tooltip />
          <el-table-column prop="contractType" :label="$t('committeeExpiredContract.table.contractType')" min-width="105" show-overflow-tooltip />
          <el-table-column prop="partyB" :label="$t('committeeExpiredContract.table.partyB')" min-width="200" show-overflow-tooltip />
          <el-table-column prop="operatorName" :label="$t('committeeExpiredContract.table.operatorName')" min-width="138" show-overflow-tooltip />
          <el-table-column prop="contractAmount" :label="$t('committeeExpiredContract.table.contractAmount')" min-width="110" show-overflow-tooltip />
          <el-table-column prop="startTime" :label="$t('committeeExpiredContract.table.startTime')" min-width="172" show-overflow-tooltip />
          <el-table-column prop="endTime" :label="$t('committeeExpiredContract.table.endTime')" min-width="172" show-overflow-tooltip />
          <el-table-column prop="state" :label="$t('committeeExpiredContract.table.state')" min-width="136">
            <template slot-scope="scope">
              <span v-if="scope.row.state==='PENDING' || scope.row.state===0" class="state-tag state-pending">待审核</span>
              <span v-else-if="scope.row.state==='APPROVED' || scope.row.state===1" class="state-tag state-approved">审核通过</span>
              <span v-else class="state-tag">{{ scope.row.state || '-' }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('committeeExpiredContract.table.action')" min-width="126" align="center">
            <template slot-scope="scope">
              <div class="action-links">
                <el-button type="text" size="small" @click="handleRenew(scope.row)">{{ $t('committeeExpiredContract.action.renew') }}</el-button>
                <el-button type="text" size="small" @click="handleStop(scope.row)">{{ $t('committeeExpiredContract.action.stop') }}</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="figma-pagination-section">
        <el-pagination background layout="total, prev, pager, next, sizes" :total="pagination.total" :current-page="pagination.page" :page-size="pagination.row" :page-sizes="[10, 20, 50]" @current-change="handlePageChange" @size-change="handleSizeChange" />
      </div>
    </div>
  </div>
</template>

<script>
import { listCommunitysByOwnerCommittee } from '@/api/owner/ownerCommitteeManageApi'
import { queryContract, queryContractType, stopContract } from '@/api/contract/expirationContractManageApi'

export default {
  name: 'CommitteeExpiredContractList',
  data() {
    return {
      loading: false,
      conditions: {
        contractName: '',
        contractNo: '',
        contractType: ''
      },
      tableData: [],
      pagination: { total: 0, page: 1, row: 10 },
      contractTypeList: [],
      communityList: []
    }
  },
  created() { this.initPage() },
  methods: {
    headerCellStyle() { return { background: '#EBF2FA', color: '#364153', fontWeight: 400, fontSize: '14px' } },
    cellStyle() { return { fontSize: '14px', color: '#1D2129', fontFamily: 'PingFang SC, Microsoft YaHei, sans-serif' } },
    rowClassName({ rowIndex }) {
      return rowIndex % 2 === 1 ? 'even-row' : ''
    },
    getListArray(res) {
      if (Array.isArray(res)) return res
      if (Array.isArray(res && res.data)) return res.data
      if (Array.isArray(res && res.records)) return res.records
      return []
    },
    getTotal(res, list) { return Number((res && (res.total || res.count || res.totalCount)) || list.length || 0) },
    async initPage() {
      await this.loadCommunities()
      this.loadContractTypes()
      this.getList()
    },
    async loadCommunities() {
      try {
        const res = await listCommunitysByOwnerCommittee({ page: 1, row: 1000 })
        this.communityList = res.data || []
      } catch (e) {
        this.communityList = []
      }
    },
    buildQueryParams() {
      return {
        page: this.pagination.page,
        row: this.pagination.row,
        communityIds: this.communityList.map(c => c.communityId).join(','),
        contractName: this.conditions.contractName,
        contractCode: this.conditions.contractNo,
        contractType: this.conditions.contractType,
        expiration: '1'
      }
    },
    async getList() {
      try {
        this.loading = true
        const res = await queryContract(this.buildQueryParams())
        const list = this.getListArray(res)
        this.tableData = list
        this.pagination.total = this.getTotal(res, list)
      } catch (e) {
        this.$message.error('获取到期合同列表失败')
      } finally {
        this.loading = false
      }
    },
    handleSearch() { this.pagination.page = 1; this.getList() },
    handleRenew(row) {
      const contractId = row.contractId || row.id
      if (!contractId) {
        this.$message.error('缺少合同ID，无法续签')
        return
      }
      this.$router.push({
        path: '/views/committee/renewContract',
        query: {
          contractId,
          contractCode: row.contractCode,
          contractName: row.contractName,
          stateName: row.stateName || row.state
        }
      })
    },
    async handleStop(row) {
      try {
        await this.$confirm('确定终止该合同？', '请确认您的操作', { type: 'warning' })
        const res = await stopContract({ id: row.id || row.contractId })
        if (res.code === 0) {
          this.$message.success('终止成功')
          this.getList()
        } else {
          this.$message.error(res.msg || '终止失败')
        }
      } catch (e) {
        if (e !== 'cancel') this.$message.error(e.message || '终止失败')
      }
    },
    async loadContractTypes() {
      try {
        const res = await queryContractType({ page: 1, row: 200 })
        this.contractTypeList = res.data || []
      } catch (e) {
        this.contractTypeList = []
      }
    },
    handlePageChange(page) { this.pagination.page = page; this.getList() },
    handleSizeChange(size) { this.pagination.row = size; this.pagination.page = 1; this.getList() }
  }
}
</script>

<style scoped>
.admin-room-container { padding: 20px; height: 100%; box-sizing: border-box; }
.figma-white-card { background: white; border-radius: 12px; padding: 20px 24px; height: 100%; display: flex; flex-direction: column; }
.figma-page-header { flex-shrink: 0; text-align: left; }
.figma-page-title { display: inline-block; font-size: 16px; font-weight: 600; color: #1D2129; margin: 0 0 12px 0; text-align: left; }
.figma-header-divider { height: 1px; background: #EBF2FA; margin-bottom: 12px; }
.figma-filter-row { display: flex; align-items: center; justify-content: space-between; }
.figma-search-group { display: flex; align-items: center; gap: 12px; }
.figma-filter-control { width: 256px; }
.figma-filter-control >>> .el-input__inner,
.figma-filter-control >>> .el-input--small .el-input__inner,
.figma-filter-control >>> .el-select .el-input__inner {
  height: 38px;
  line-height: 38px;
  border-radius: 10px;
  border: 1px solid #DCE6F5;
  font-size: 14px;
  font-family: Inter, PingFang SC, Microsoft YaHei, sans-serif;
  color: #1D2129;
  background: #fff;
  padding: 0 16px;
}
.figma-filter-control >>> .el-input__inner::placeholder {
  color: #8C9BB4;
  font-size: 14px;
  font-family: Inter, PingFang SC, Microsoft YaHei, sans-serif;
}
.figma-filter-control >>> .el-select .el-input .el-select__caret {
  color: #364153;
}
.figma-btn-refresh {
  width: 38px !important;
  height: 38px !important;
  padding: 0 !important;
  background: #fff !important;
  border: 1px solid #DCE6F5 !important;
  color: #364153 !important;
  border-radius: 10px !important;
}
.figma-btn-search {
  width: 84px !important;
  height: 38px !important;
  padding: 0 !important;
  background: #fff !important;
  border: 1px solid #0E76FF !important;
  color: #0E76FF !important;
  border-radius: 10px !important;
  font-size: 14px !important;
  font-family: Inter, PingFang SC, Microsoft YaHei, sans-serif;
  font-weight: 500 !important;
}
.figma-btn-search >>> i {
  margin-right: 4px;
}
.figma-table-section { flex: 1; margin-top: 12px; overflow: auto; }
.figma-table-section >>> .el-table .even-row {
  background: #F8FBFF;
}
.figma-table-section >>> .el-table th {
  font-weight: 400;
}
.figma-table-section >>> .el-table td {
  font-family: PingFang SC, Microsoft YaHei, sans-serif;
}
.figma-pagination-section { display: flex; justify-content: flex-end; padding-top: 16px; flex-shrink: 0; }
.action-links { display: inline-flex; align-items: center; gap: 8px; color: #0E76FF; }
.action-links >>> .el-button--text {
  color: #0E76FF;
}
.state-tag {
  display: inline-block;
  padding: 3px 12px;
  border-radius: 8px;
  font-size: 14px;
  font-family: PingFang SC, Microsoft YaHei, sans-serif;
  font-weight: 400;
  line-height: 20px;
}
.state-pending {
  background: rgba(255, 105, 0, 0.10);
  border: 1px solid #FF6900;
  color: #FF6900;
}
.state-approved {
  background: rgba(14, 118, 255, 0.10);
  border: 1px solid #0E76FF;
  color: #0E76FF;
}
</style>
